import { CircularProgress, useTheme } from '@mui/material';

import { secondaryColors } from '@/theme/colors';
import { StyledWrapper } from '@/components/Loader/Loader.styled';

interface ILoaderProps {
  isTopMargin?: boolean;
  className?: string;
}

const Loader = ({ isTopMargin = true, className }: ILoaderProps) => {
  const { palette } = useTheme();
  const loaderColor = palette.customSecondary?.primary?.DEFAULT || secondaryColors.primary.DEFAULT;

  return (
    <StyledWrapper isTopMargin={isTopMargin} className={className}>
      <CircularProgress style={{ color: loaderColor }} />
    </StyledWrapper>
  );
};

export default Loader;
